/**
 * Booking via Google Calendar appointment schedules (payment at booking when enabled in Google).
 * Per-service Virtual / In-Person links live in `data/serviceBookingLinks.ts`.
 */
import { hasServiceBookingLinks } from './data/serviceBookingLinks';

export const BOOKING_FLOW_ENABLED = true;

export const CONTACT_PATH = '/contact';

/** Primary “Book a Session” destination */
export const BOOK_SESSION_PATH = BOOKING_FLOW_ENABLED ? '/services' : CONTACT_PATH;

export function serviceCardUsesExternalBook(card: {
  id: string;
  bookUrl?: string;
}): boolean {
  if (!BOOKING_FLOW_ENABLED) return false;
  if (card.id === 'speaking-engagements') return false;
  if (hasServiceBookingLinks(card.id)) return true;
  const trimmed = card.bookUrl?.trim() ?? '';
  return Boolean(trimmed && !/calendly\.com/i.test(trimmed));
}

/** @deprecated Single bookUrl — prefer Virtual / In-Person links in serviceBookingLinks.ts */
export function resolveServiceBookUrl(bookUrl: string | undefined): string {
  if (!BOOKING_FLOW_ENABLED) return '';
  const trimmed = bookUrl?.trim() ?? '';
  if (/calendly\.com/i.test(trimmed)) return '';
  return trimmed;
}
